import { MainLayout } from '@components/layouts/MainLayout'
import { PurchaseForm } from '@components/purchase'
import { IconButton } from '@components/ui/IconButton'
import { useNavigate } from 'react-router-dom'

// 購入機能の公開フラグ（trueに変更すると購入画面が利用可能になります）
const STORE_ENABLED = true

export const Store: React.FC = () => {
  const navigate = useNavigate()

  const handleClose = () => {
    navigate(-1)
  }

  return (
    <MainLayout
      activeMain="store"
      showBottomNav={false}
      outerClassName="bg-white"
      className="bg-white"
      contentClassName="px-4 pb-6"
      header={{
        enabled: true,
        title: '購入',
        leftIcon: null,
        rightIcon: null,
        leftSlot: <IconButton aria-label="閉じる" icon="Close" onClick={handleClose} />,
        rightSlot: (
          <IconButton aria-label="メニュー" icon="Dots" className="invisible pointer-events-none" />
        ),
        className: 'flex h-16 w-full items-center justify-between px-2',
        containerClassName: 'px-4 pt-2',
        scrolledClassName: 'supports-[backdrop-filter]:backdrop-blur-[1px]',
      }}
    >
      {STORE_ENABLED ? (
        <div className="flex min-h-full flex-col pt-2">
          <PurchaseForm />
        </div>
      ) : (
        <div className="flex flex-1 flex-col items-center justify-center gap-4 py-20">
          <p className="text-lg font-semibold text-[#18181b]">準備中</p>
          <p className="text-sm text-[#71717a] text-center leading-relaxed">
            購入機能は現在準備中です。
            <br />
            公開までしばらくお待ちください。
          </p>
        </div>
      )}
    </MainLayout>
  )
}

export default Store
